import { useEffect, useRef } from 'react';
import { sortCards } from '@balansa/shared';
import { useApp, useWheel } from '../store';
import { GameCard } from './GameCard';

/** Kāršu drukas lapa: visas kārtis 63 × 88 mm uz A4. */
export function PrintSheet() {
  const printing = useApp((s) => s.printing);
  const setPrinting = useApp((s) => s.setPrinting);
  const { wheel, idx } = useWheel();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!printing) return;
    document.body.classList.add('printing-cards');
    let cancelled = false;
    const done = () => {
      document.body.classList.remove('printing-cards');
      setPrinting(false);
    };
    window.addEventListener('afterprint', done, { once: true });
    const imgs = Array.from(ref.current?.querySelectorAll('img') || []);
    const loaded = Promise.all(imgs.map((im) => (im.complete ? 0 : new Promise((r) => (im.addEventListener('load', r), im.addEventListener('error', r))))));
    void Promise.race([loaded, new Promise((r) => setTimeout(r, 4000))]).then(() => {
      if (!cancelled) setTimeout(() => window.print(), 80);
    });
    return () => {
      cancelled = true;
      window.removeEventListener('afterprint', done);
      document.body.classList.remove('printing-cards');
    };
  }, [printing, setPrinting]);

  return (
    <div id="print-sheet" ref={ref} aria-hidden="true">
      {printing
        ? sortCards(wheel.cards, idx, wheel.settings.cardSort ?? 'added-desc').map((c) => (
            <GameCard key={c.id} card={c} idx={idx} eager number={wheel.cards.indexOf(c) + 1} />
          ))
        : null}
    </div>
  );
}
